export default "__VITE_ASSET__DejMjMmP__"